































































































































import { GeekJobInfo } from '@/models';
import { OpportunityActions, OpportunityMembershipStatus, Opportunity } from '@/models/opportunities';
import { isMaxLengthRuleBroken } from '@/shared';
import { Actions, typedStore, Mutations } from '@/store';
import { isObjectEmpty, resetModel } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'SetGeekJobInfoModal',
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
      form: {
        department: '',
        location: '',
        designation: '',
        practice: '',
        additionalInfo: null as unknown as string,
      } as GeekJobInfo,
    };
  },
  computed: {
    modalTitle(): string {
      if (isObjectEmpty(this.geekJobInfo)) {
        return this.$t('opportunities.set-geek-job-info-modal.title-review') as string;
      }

      return this.$t('opportunities.set-geek-job-info-modal.title-provide') as string;
    },
    geekJobInfo(): GeekJobInfo {
      return typedStore(this).state.geek.geekJobInfo;
    },
  },
  methods: {
    async fetchGeekJobInfo() {
      this.form = resetModel(this.form);
      await this.$validator.reset();
      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(Actions.geek.fetchGeekJobInfo, this.$route.params.geekId);
        if (isObjectEmpty(this.geekJobInfo)) {
          this.form = this.geekJobInfo;
        }
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    async applyToOpportunity() {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(
          Actions.opportunities.changeMembershipStatus,
          { id: this.$route.params.id, status: OpportunityMembershipStatus.Waiting, ...this.form },
        );
        this.$bvModal.hide('set-geek-job-info-modal');
        this.$bvModal.show('status-change-opportunity-modal');
        this.$emit('refresh');
      } finally {
        this.loader.isRequestPending = false;
      }
    },
  },
});
